import React from 'react';
import { Shield, CheckCircle, FileText, Award, Mail, Database } from 'lucide-react';
const EMAIL = 'info@uk-medicolegal-assessment.com';
export function Footer() {
  return <footer className="bg-[#1A2B3C] text-slate-300 py-10 md:py-12 border-t border-slate-700" data-id="element-176">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-177">
        {/* Trust Badges Section */}
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 pb-6 border-b border-slate-700/50 mb-6" data-id="element-178">
          <div className="flex items-center space-x-3" data-id="element-179">
            <Shield className="h-5 w-5 text-sage-500 flex-shrink-0" data-id="element-180" />
            <span className="text-sm font-medium text-white" data-id="element-181">
              ISO 27001 Certified
            </span>
          </div>
          <div className="flex items-center space-x-3" data-id="element-182">
            <CheckCircle className="h-5 w-5 text-sage-500 flex-shrink-0" data-id="element-183" />
            <span className="text-sm font-medium text-white" data-id="element-184">
              ICO Registered
            </span>
          </div>
          <div className="flex items-center space-x-3" data-id="element-185">
            <FileText className="h-5 w-5 text-sage-500 flex-shrink-0" data-id="element-186" />
            <span className="text-sm font-medium text-white" data-id="element-187">
              £10m PI Insurance
            </span>
          </div>
          <div className="flex items-center space-x-3" data-id="element-188">
            <Award className="h-5 w-5 text-sage-500 flex-shrink-0" data-id="element-189" />
            <span className="text-sm font-medium text-white" data-id="element-190">
              Expert Witness Institute
            </span>
          </div>
          <div className="flex items-center space-x-3" data-id="element-191">
            <Database className="h-5 w-5 text-teal-400 flex-shrink-0" data-id="element-192" />
            <span className="text-sm font-medium text-teal-400" data-id="element-193">
              UK Data Residency
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 lg:gap-6 mb-6" data-id="element-194">
          <div className="col-span-1 md:col-span-2" data-id="element-195">
            <div className="flex items-center space-x-3 mb-4" data-id="element-196">
              <img src="https://cdn.magicpatterns.com/uploads/cfHMrrPng3iagpRwV1FuNs/Favicon.jpg" alt="UK Medicolegal Assessments shield logo" className="h-10 w-10 rounded-lg object-contain" data-id="element-197" />
              <span className="text-xl font-bold text-white tracking-tight" data-id="element-198">
                UK<span className="text-teal-500" data-id="element-199"> MEDICOLEGAL</span>{' '}
                ASSESSMENTS
              </span>
            </div>
            <p className="text-sm leading-relaxed max-w-sm mb-4 text-slate-400" data-id="element-200">
              Providing expert medical reporting services to the legal and
              insurance sectors across the United Kingdom. Professional,
              independent, and reliable clinical assessments.
            </p>
            <div className="text-sm text-slate-300" data-id="element-201">
              <p className="flex items-center" data-id="element-202">
                <Mail className="h-4 w-4 mr-2.5 text-teal-500 flex-shrink-0" data-id="element-203" />
                <a href={`mailto:${EMAIL}`} className="hover:text-teal-400 transition-colors duration-200" data-id="element-204">
                  {EMAIL}
                </a>
              </p>
            </div>
          </div>

          <div data-id="element-205">
            <h3 className="text-white font-semibold mb-3 tracking-wide text-sm uppercase" data-id="element-206">
              Services
            </h3>
            <ul className="space-y-1" data-id="element-207">
              <li data-id="element-208">
                <a href="/services/personal-injury" className="block py-2 text-sm hover:text-teal-400 transition-colors duration-200 min-h-[44px] flex items-center" data-id="element-209">
                  Personal Injury
                </a>
              </li>
              <li data-id="element-210">
                <a href="/services/clinical-negligence" className="block py-2 text-sm hover:text-teal-400 transition-colors duration-200 min-h-[44px] flex items-center" data-id="element-211">
                  Clinical Negligence
                </a>
              </li>
              <li data-id="element-212">
                <a href="/services/immigration" className="block py-2 text-sm hover:text-teal-400 transition-colors duration-200 min-h-[44px] flex items-center" data-id="element-213">
                  Immigration
                </a>
              </li>
              <li data-id="element-214">
                <a href="/services/family-court" className="block py-2 text-sm hover:text-teal-400 transition-colors duration-200 min-h-[44px] flex items-center" data-id="element-215">
                  Family Court
                </a>
              </li>
              <li data-id="element-216">
                <a href="/services/criminal-cases" className="block py-2 text-sm hover:text-teal-400 transition-colors duration-200 min-h-[44px] flex items-center" data-id="element-217">
                  Criminal Cases
                </a>
              </li>
              <li data-id="element-218">
                <a href="/services/industrial-disease" className="block py-2 text-sm hover:text-teal-400 transition-colors duration-200 min-h-[44px] flex items-center" data-id="element-219">
                  Industrial Disease
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-220">
            <h3 className="text-white font-semibold mb-3 tracking-wide text-sm uppercase" data-id="element-221">
              Legal
            </h3>
            <ul className="space-y-1" data-id="element-222">
              <li data-id="element-223">
                <a href="/privacy-policy" className="block py-2 text-sm hover:text-teal-400 transition-colors duration-200 min-h-[44px] flex items-center" data-id="element-224">
                  Privacy & Cookie Policy
                </a>
              </li>
              <li data-id="element-225">
                <a href="/terms-conditions" className="block py-2 text-sm hover:text-teal-400 transition-colors duration-200 min-h-[44px] flex items-center" data-id="element-226">
                  Terms & Conditions
                </a>
              </li>
              <li data-id="element-227">
                <a href="/cancellation-policy" className="block py-2 text-sm hover:text-teal-400 transition-colors duration-200 min-h-[44px] flex items-center" data-id="element-228">
                  Cancellation Policy
                </a>
              </li>
              <li data-id="element-229">
                <a href="/faq" className="block py-2 text-sm hover:text-teal-400 transition-colors duration-200 min-h-[44px] flex items-center" data-id="element-230">
                  FAQ
                </a>
              </li>
              <li data-id="element-231">
                <a href="/contact" className="block py-2 text-sm hover:text-teal-400 transition-colors duration-200 min-h-[44px] flex items-center" data-id="element-232">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-slate-700/50 pt-5 flex flex-col md:flex-row justify-between items-center gap-3" data-id="element-233">
          <p className="text-xs text-slate-500" data-id="element-234">
            &copy; {new Date().getFullYear()} UK Medicolegal Assessment Ltd. All
            rights reserved.
          </p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-235">
            <a href="/privacy-policy" className="text-xs text-slate-500 hover:text-white transition-colors duration-200 min-h-[44px] flex items-center" data-id="element-236">
              Privacy & Cookies
            </a>
            <a href="/terms-conditions" className="text-xs text-slate-500 hover:text-white transition-colors duration-200 min-h-[44px] flex items-center" data-id="element-237">
              Terms
            </a>
            <a href="/cancellation-policy" className="text-xs text-slate-500 hover:text-white transition-colors duration-200 min-h-[44px] flex items-center" data-id="element-238">
              Cancellation
            </a>
            <a href="/contact" className="text-xs text-slate-500 hover:text-white transition-colors duration-200 min-h-[44px] flex items-center" data-id="element-239">
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>;
}